import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _StarFilled = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: props.strokeWidth || 1.5,
                d: "m15 9-2.7764-5.5528c-.0921-.1843-.3551-.1843-.4472 0l-2.7764 5.5528-5.5535.9256c-.194.0323-.2765.2657-.1458.4127l3.6993 4.1617-.9265 6.0222c-.0308.2005.1774.3523.359.2616l5.5675-2.7838 5.5676 2.7838c.1815.0907.3897-.0611.3589-.2616l-.9265-6.0222 3.6993-4.1617c.1307-.147.0483-.3804-.1457-.4127l-5.5536-.9256Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                fill: "currentColor",
                d: "m15 9-3-6-3 6-6 1 4 4.5-1 6.5 6-3 6 3-1-6.5 4-4.5-6-1Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const StarFilled = addPropsToSVG(_StarFilled);

export { StarFilled };
